import { Injectable } from '@angular/core';
import { BillDiscountRequest, BillMarkupRequest, ICategory, PracticeRatesService, ProviderDiscount, ProviderMarkup } from '@harlowe/core';
import { TealHealthMedicalService } from './medical.service';

@Injectable()
export class TealHealthPracticeRatesService extends PracticeRatesService
{
    constructor(private _medicalService: TealHealthMedicalService) { super(); }

    override addPracticeMarkup(ein: string, request: BillMarkupRequest): Promise<void>
    {
        return this._medicalService.addPracticeMarkup(ein, request);
    }

    override addPracticeDiscount(ein: string, request: BillDiscountRequest): Promise<void>
    {
        return this._medicalService.addPracticeDiscount(ein, request);
    }

    override getCategories(): Promise<ICategory[]>
    {
        return this._medicalService.getCategories();
    }

    override getLocationMarkups(ein: string, locationId: number, npi: string): Promise<ProviderMarkup[]>
    {
        return this._medicalService.getLocationMarkups(ein, locationId, npi);
    }

    override getLocationDiscounts(ein: string, locationId: number, npi: string): Promise<ProviderDiscount[]>
    {
        return this._medicalService.getLocationDiscounts(ein, locationId, npi);
    }

    override addLocationMarkup(ein: string, locationId: number, npi: string, request: BillMarkupRequest): Promise<ProviderMarkup>
    {
        return this._medicalService.addLocationMarkup(ein, locationId, npi, request);
    }

    override addLocationDiscount(ein: string, locationId: number, npi: string, request: BillDiscountRequest): Promise<ProviderDiscount>
    {
        return this._medicalService.addLocationDiscount(ein, locationId, npi, request);
    }

    override deleteLocationMarkup(ein: string, locationId: number, npi: string, markupId: number): Promise<void>
    {
        return this._medicalService.deleteLocationMarkup(ein, locationId, npi, markupId);
    }

    override deleteLocationDiscount(ein: string, locationId: number, npi: string, discountId: number): Promise<void>
    {
        return this._medicalService.deleteLocationDiscount(ein, locationId, npi, discountId);
    }
}
